import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { userLogin } from "../../Services/api";
import { toast } from 'react-toastify';
import NodeaxiosInstance from "../../Services/nodeaxios";
import UserLogo from "../../Assets/Images/LogoUser.png"
import topBanaer from "../../Assets/Images/user_login_screen_top.png"
const PasswordForgot = () => {
    const [isLoading, setLoadingStatus] = useState(false);
    const [input, setInput] = useState("");
    const [isEmail, setIsEmail] = useState(false);
    const navigate = useNavigate();


    const handleInputChange = (e) => {
        let value = e.target.value;

        if (/[a-zA-Z@]/.test(value)) {
            setIsEmail(true);
            setInput(value);
            return;
        }

        // Otherwise treat as mobile
        setIsEmail(false);

        value = value.replace(/\D/g, '');

        if (value.length > 10) value = value.slice(0, 10);

        if (value && !/^[6-9]/.test(value)) return;

        setInput(value);
    };


    const loginWithinput = () => {

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (isEmail) {
            if (!input || !emailRegex.test(input)) {
                toast("Please enter a valid email address", {
                    position: "bottom-center",
                    autoClose: 3000,
                    hideProgressBar: true,
                    theme: "light",
                    className: 'text-danger toast-style-1'
                });
                return;
            }
        }

        if (!isEmail) {
            if (!input || input.length != 10 || !/^[6-9]\d{9}$/.test(input)) {
                toast("Please enter a valid 10-digit mobile number", {
                    position: "bottom-center",
                    autoClose: 3000,
                    hideProgressBar: true,
                    theme: "light",
                    className: 'text-danger toast-style-1'
                });
                return;
            }
        }

        setLoadingStatus(true);

        const param = {
            inputType: isEmail ? 1 : 2,
            inputValue: input.trim()
        };

        NodeaxiosInstance.post('auth/forgot-password/otp', param)
            .then((res) => {
                if (res.data.status == "1") {
                    navigate('/verify-Forgot-Otp', { state: { inputType: isEmail ? 1 : 2, inputValue: input } });
                }
            })
            .catch(error => {
                toast(error?.response?.data?.message || "Something went wrong", {
                    position: "bottom-center",
                    autoClose: 3000,
                    hideProgressBar: true,
                    theme: "light",
                    className: 'text-danger toast-style-1'
                });
            })
            .finally(() => setLoadingStatus(false));
    };

    const checkBtnDisable = () => {
        if (!input) {
            return true;
        }
        if (isEmail) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(input)) {
                return true;
            }
        } else {
            if (input.length != 10 || !/^[6-9]\d{9}$/.test(input)) {
                return true;
            }
        }
        return false;
    };

    return (
        <>
            <div className=" bg-white ">
                <div className="position-relative">
                    <img src={topBanaer} height="110px" width="100%" />
                    <img src={UserLogo} height="80px" width="80px" className="rounded-3 position-absolute top-100 start-50 translate-middle  mb-2 " />
                </div>
                <div className="loginPage loginFlow py-3 bg-white vh-100 d-flex align-items-center">
                    <div className="w-100 ">
                        <div className="ff-poppins-bold fs-24  ">Forgot password  </div>
                        <span className="mb-3 ff-poppins-medium fs-16">Email or Phone Number</span>
                        <div className="input-group ff-poppins-regular w-100">
                            <div className="input-group ff-poppins-regular">
                                <input
                                    type="text"
                                    value={input}
                                    onChange={handleInputChange}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            e.target.blur();
                                        }
                                    }}
                                    // inputMode={/^\d*$/.test(input) ? "numeric" : "email"}
                                    autoComplete="off"
                                    className="form-control rounded-0 border-0 text-dark no-spinners w-100 ff-poppins-medium fs-18"
                                    placeholder="Enter Email or Phone Number"
                                />
                            </div>

                        </div>
                        <div className="d-flex justify-content-center">
                            <button disabled={checkBtnDisable()} type="submit" onClick={loginWithinput}
                                className={`${isLoading ? "loading" : ""} ${checkBtnDisable() ? "opacity-40" : ""} w-100 border-0 primary-bg rounded-pill 
                    ff-poppins-semiBold fs-18 text-white mt-4 mb-2 d-flex justify-content-center align-items-center`}>
                                {
                                    isLoading
                                        ?
                                        <span className="loader-style-1"></span>
                                        :
                                        <span>Get verification code </span>
                                }
                            </button>

                        </div>
                        <div className="text-center fs-12 ff-poppins-medium mt-2" onClick={() => navigate('/login', { state: { tabName: "Register", fromGuest: true } })}>
                            Don't have an account?
                            <span className="primary-text ms-1">Register.</span>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
};

export default PasswordForgot;